import { render, staticRenderFns } from "./TabLockerHolders.vue?vue&type=template&id=4894200a&scoped=true"
import script from "./TabLockerHolders.vue?vue&type=script&lang=js"
export * from "./TabLockerHolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894200a",
  null
  
)

export default component.exports